<div class="user-access-skin min-vh-100 d-flex flex-column linear-gradient-primary">
  <div class="mw-100 m-auto">
    <main class="bg-white mw-100 rounded">
      <div class="tab-btns-wrap d-flex">
        <a routerLink="/access/login" routerLinkActive="tab-btn--active" class="tab-btn">Login</a>
        <a routerLink="/access/register" routerLinkActive="tab-btn--active" class="tab-btn">Register</a>
      </div>
      <div class="px-2 py-5">
        <!-- <h1 class="text-center">
          <img src="{{schoollogourl}}" class="logoImg">
        </h1> -->
        <div class="text-center mb-5">
          <!-- <img src="../../../assets/img/learning-and-development.png" class="banner mw-100 mt-4 mb-5"> -->
          <img src="{{schoollogourl}}" class="logoImg">
        </div>
        <router-outlet></router-outlet>
      </div>
    </main>
    <!-- <footer>
      <p class="mt-3 mb-0 text-center text-sm text-white">&copy; {{ currentDate | date: 'yyyy'}} <a href="http://todayssolutions.com.ng" target="_blank" rel="noopener noreferrer" class="text-reset copyright-link">Today's Solutions</a></p>
    </footer> -->
  </div>
</div>
